import AliceCarousel from "react-alice-carousel";
import "./carouse.css";

export const Carousel = AliceCarousel;
